import { useState } from "react";
import { toast } from "react-toastify";
import { useVillageWiseMandaliCountExportData } from "../../API_Master/ExcelAPI";
import { exportToExcel, notifyError } from "../../MethodMaster/JSXComponentMothod";
import VillageWiseMandalHeader from "../../Pages/Dashboard/VillageWiseMandalHeader";

const ShimmerCard = () => (
  <div className="govdash-villageCard-final">
    <div className="village-shimmer" style={{ height: "1rem", marginBottom: "0.6rem" }}></div>
    <div className="village-shimmer" style={{ height: "1.7rem" }}></div>
  </div>
);

const NoDataCard = () => (
  <div className="govdash-villageCard-final govdash-noVillageCard">
    <div className="govdash-noDataIcon">
      <i className="fas fa-village fa-2x"></i>
    </div>
    <div className="govdash-noDataTitle">No Villages Found</div>
    <div className="govdash-noDataDesc">
      {document.querySelector(".govdash-searchInput")?.value ? "Try searching with different keywords" : "No villages available under this Yojana"}
    </div>
  </div>
);

export default function VillageWiseMandaliCount({
  villageWiseMandaliCountData,
  fetchingVillageWiseMandaliCountData,
  // villageWiseBhajanMandaliData,
  // fetchingVillageWiseBhajanMandaliData,
  selectedBhajanMandaliType,
  handleNavigateToMainTab,
  setSelectedVillage,
  setCurrentBhjanMandaliState,
  // bhajanMandaliTypeID,
  // selectedVillage,
  // currBhajanMandaliState,
}) {
  const [search, setSearch] = useState("");
  const themes = ["glass-0", "glass-1", "glass-2", "glass-3", "glass-4"];

  const { mutate: exportVillageWiseMandaliCount, isPending: isExporting } = useVillageWiseMandaliCountExportData();

  const filteredData = villageWiseMandaliCountData?.filter((v) => v.VillageName.toLowerCase().includes(search.toLowerCase()));

  const handleVillageSelect = (v) => {
    setSelectedVillage(v);
    setCurrentBhjanMandaliState("villageWiseMandali");
  };

  const handleExport = () => {
    toast.dismiss();
    exportVillageWiseMandaliCount(selectedBhajanMandaliType, {
      onSuccess: (VillageMandaliData) => {
        if (!VillageMandaliData.length) {
          return notifyError("No Data Found");
        }
        const exportData = VillageMandaliData.map((item, index) => ({
          "Sr No ": index + 1,
          "Village Name": item?.VillageName || "",
          "Total Bhajan Mandali": item?.TotalBhajanMandali || "",
          "Total Members": item?.TotalBhajanMandaliMember || "",
        }));

        exportToExcel(exportData, "Bhajan_Mandali_Excel", {}, selectedBhajanMandaliType?.bhajanMandaliType);
      },
      onError: () => {
        return notifyError("Export failed. Please try again.");
      },
    });
  };
  return (
    <>
      <VillageWiseMandalHeader
        selectedBhajanMandaliType={selectedBhajanMandaliType}
        handleNavigateToMainTab={handleNavigateToMainTab}
        villageCount={villageWiseMandaliCountData?.length}
        theme={selectedBhajanMandaliType?.theme}
      />
      <div className="d-flex justify-content-between">
        <h3 className={"govdash-sectionTitle"}>Village Wise Mandali Count</h3>
        <div className="d-flex gap-2">
          <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="govdash-searchWrapper">
              <i className="fas fa-search "></i>
              <input type="text" placeholder="Search Village Name..." value={search} onChange={(e) => setSearch(e.target.value)} className="govdash-searchInput" />
              {search && (
                <button onClick={() => setSearch("")} className="govdash-clearSearch">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
          <div>
            <button onClick={handleExport} className="govdash-excelBtn mt-4" disabled={isExporting}>
              {isExporting ? (
                <>
                  <i className="fas fa-file-excel"></i>
                  <span className="govdash-btnLoader" />
                </>
              ) : (
                <>
                  <i className="fas fa-file-excel"></i>
                  <span className="ms-2">Export Excel</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      <div className="govdash-villageGrid-final">
        {fetchingVillageWiseMandaliCountData ? (
          Array(villageWiseMandaliCountData?.length)
            .fill()
            .map((_, i) => <ShimmerCard key={i} />)
        ) : filteredData.length > 0 ? (
          filteredData.map((v, idx) => {
            const theme = themes[idx % 5];

            return (
              <div key={v.VillageID} className={`govdash-villageCard-final yojna-${theme}`} onClick={() => handleVillageSelect(v)}>
                <div className="village-header-final">
                  <div className="village-name-final">{v.VillageName}</div>
                </div>
                <div className="beneficial-row-final">
                  <span className="label">Mandali Count</span>
                  <span className="value">{v.TotalBhajanMandali?.toLocaleString() ?? "0"}</span>
                </div>

                <div className="member-card-minimal">
                  <div className="member-card-content">
                    <span className="member-card-label">Member Count</span>
                    <span className="member-card-value">{v.TotalBhajanMandaliMember?.toLocaleString() ?? "0"}</span>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <NoDataCard />
        )}
      </div>
    </>
  );
}
